import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SpecialPaymentInfo {
  fundName: string;
  paymentAmount: string;
  source: string;
  sourceID: string;
  funds: any[];
  specialPaymentName: any[];
  accountCode: string;
  note:string;
}

const initialState: SpecialPaymentInfo = {
  fundName: "",
  paymentAmount: "",
  source: "",
  sourceID: "",
  funds: [],
  specialPaymentName: [],
  accountCode: "",
  note:"",
};

const createSpecialPaymentSlice = createSlice({
  name: "specialPayment",
  initialState,
  reducers: {
    setCreateSpecialPayment: (
      state,
      action: PayloadAction<Partial<SpecialPaymentInfo>>
    ) => {
      return { ...state, ...action.payload };
    },
    removeSpecialPayment: () => initialState,
  },
});

export const { setCreateSpecialPayment, removeSpecialPayment } =
  createSpecialPaymentSlice.actions;
export default createSpecialPaymentSlice.reducer;
